import { FeatureValuesHierarchy } from '../../../../store/features/selectors'
import { renderRow } from '../utils'
import { isAdminDisabledInUrl } from '../../../../store/features/featuresService.general'

const ROW_TITLES: Record<FeatureValuesHierarchy[number]['name'], string> = {
  tariffFeatures: 'Base tariff features',
  envFeatures: 'Instance features',
  enabledGateFeatures: 'Statsig enabled features',
  get adminFeaturesFromTariff() {
    return isAdminDisabledInUrl()
      ? 'Tariff admin features'
      : 'Tariff admin features<br/><a style="font-weight: normal" href="?noAdmin">view as non-admin</a>'
  },
  betaFeaturesExpanded: 'Beta features',
  get adminFeatures() {
    return isAdminDisabledInUrl()
      ? 'Other admin features'
      : 'Other admin features<br/><a style="font-weight: normal" href="?noAdmin">view as non-admin</a>'
  },
  forcedEnvFeatures: 'Forced instance features',
  devForcedFeatures: 'Devtools-forced features'
}

export function renderFeatureHierarchy(hierarchy: FeatureValuesHierarchy) {
  return hierarchy
    .map(({ name, values }, index) => {
      if (isAdminDisabledInUrl() && ['adminFeaturesFromTariff', 'adminFeatures'].includes(name)) {
        return renderRow(
          ROW_TITLES[name],
          'You are currently in no-admin mode - <a style="font-weight: normal" href="?">view as admin again</a>'
        )
      }

      if (!Object.keys(values).length) {
        return ''
      }

      const higherSets = hierarchy.slice(index + 1)
      const higherValues = Object.assign({}, ...higherSets.map(set => set.values))

      return renderRow(ROW_TITLES[name], renderFeatures(values, higherValues))
    })
    .join('')
}

export function renderFeatures(
  features: object,
  higherFeatures: object,
  prefix: string = ''
): string {
  return Object.entries(features)
    .sort(([f1], [f2]) => (f1 > f2 ? 1 : -1))
    .map(([feature, value]) => renderFeature(feature, value, higherFeatures, prefix))
    .join('<br/>')
}

function renderFeature(
  feature: string,
  value: string,
  higherFeatures: object,
  prefix: string = ''
) {
  const isOverridden = Object.keys(higherFeatures).includes(feature)

  if (isOverridden) {
    return `${prefix}<s>${feature} → ${value}</s>`
  }

  return `${prefix}${feature} → ${value}`
}
